(function(){
    'use strict'

    angular
    .module('app.departamentos')
    .controller('EditarDepartamento', EditarDepartamento);

    EditarDepartamento.$inject = ['$scope', '$animationsSrv', '$routeParams','DepartamentosService', 'CentrosCostoService', 'logger', '$location', 'UserInfoService'];

    function EditarDepartamento($scope, $animationsSrv, $routeParams, DepartamentosService, CentrosCostoService, logger, $location, UserInfoService) {
    
        $animationsSrv.scrollToTop();
        
        var vm = this;
        vm.centrosCosto = [];
        vm.departamento = {
            centroCostoId: -1
        };

        vm.departamentoId = $routeParams.id ? $routeParams.id : 0;

        var promiseCentroCosto = getCentrosCosto();

        if(vm.departamentoId){
            getDepartamento(promiseCentroCosto);
        }

        function getCentrosCosto(){
            var promise = CentrosCostoService.getAll(UserInfoService.getCompaniaId())
            .then(function(centrosCosto){
                vm.centrosCosto = centrosCosto;
            })
            .catch(function(error){
                $logger.error('Error al obtener los centros de costo')
            }); 
            
            return promise;
        }

        function getDepartamento(promiseCentroCosto){

            promiseCentroCosto.then(function(){
                if(vm.departamentoId != 0){
                    var promise = DepartamentosService.getById(UserInfoService.getCompaniaId(), vm.departamentoId);
    
                    promise
                    .then(function(departamento){
                        vm.departamento = departamento;
                    })
                    .catch(function(error){
                        switch (error.status) {
                            case 401:
                                logger.error('La sesión ha expirado');
                                break;
                        
                            default:
                                logger.error('Hubo un error al obtener el departamento: ' + error.data.Message);
                                break;
                        }
                    });               
                }
            });

        };

        vm.save = function(){

            $scope.submitted = true;

            if($scope.departamentoForm.$valid){
                if(!vm.departamento.id){
                    saveDepartamento();
                }
                else if($scope.departamentoForm.$dirty){
                    updateDepartamento();
                }
                else{
                    logger.info('No has modificado ningún dato!');
                }
            }     
        
        };

        function saveDepartamento() {
            var promise = DepartamentosService.save(vm.departamento);
            
            promise
            .then(function(response){
                logger.success('Departamento creado con éxito.');
                clearDepartamentoData();
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sesión ha expirado');
                        break;
                
                    default:
                        logger.error('Hubo un error al crear el departamento: ' + error.data.Message);
                        break;
                }
            });   
        };

        function updateDepartamento(){
            var promise = DepartamentosService.update(vm.departamento);
            
            promise
            .then(function(response){
                logger.success('Departamento modificado con éxito.');
                $location.path('/departamentos');
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sesión ha expirado');
                        break;
                
                    default:
                        logger.error('Hubo un error al modificar el departamento: ' + error.data.Message);
                        break;
                }
            });   
        };

        function clearDepartamentoData(){
            $scope.submitted = false;
            // Reset the form model.
            vm.departamento = {
                centroCostoId: -1
            };
            // Set back to pristine.
            $scope.departamentoForm.$setPristine();
            // Since Angular 1.3, set back to untouched state.
            $scope.departamentoForm.$setUntouched();
        };

    }
})();